import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Critical namespace'ler — login/register/auth flow icin gerekli.
// Eager import: ilk paint'te hazir olmali.
import trCommon from '@/locales/tr/common.json';
import trAuth from '@/locales/tr/auth.json';

// Non-critical namespace'ler (musteri, firsat) authenticated route'larda
// kullanilir; lazy yuklenir → eager bundle'dan ~10-15 KB tasarruf.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'tr',
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    resources: {
      tr: {
        common: trCommon,
        auth: trAuth,
      },
    },
  });

// App bootstrap'inda idle'da non-critical namespace'leri yukle.
// useTranslation('musteri') ilk render'da fallback key dondurur, sonra swap.
function loadDeferredLocales() {
  void import('@/locales/tr/musteri.json').then((mod) => {
    i18n.addResourceBundle('tr', 'musteri', mod.default, true, true);
  });
  void import('@/locales/tr/firsat.json').then((mod) => {
    i18n.addResourceBundle('tr', 'firsat', mod.default, true, true);
  });
  void import('@/locales/tr/rehber.json').then((mod) => {
    i18n.addResourceBundle('tr', 'rehber', mod.default, true, true);
  });
}
if (typeof window !== 'undefined') {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(loadDeferredLocales, { timeout: 2000 });
  } else {
    setTimeout(loadDeferredLocales, 500);
  }
}

export { i18n };
